import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "mobile-modal__top" }

import { IMegaMenuActiveItemOverwrite, IMegaMenuItem } from '@/types/megaMenuTypes';
import { PanelBar as KPanelBar, PanelBarSelectEventArguments } from '@progress/kendo-vue-layout';
import { computed } from 'vue';
import { IMobileMenuItem } from '@/types/mobileMenuTypes';
import UserSearchBox from '@/components/userArea/UserSearchBox.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MegaMenuMobile',
  props: {
    megaMenuItems: {},
    activeMegaMenuItemOverwrite: {}
  },
  emits: ["close-mobile-menu"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const menuItems = computed(() => {
  return createMenuItemsFromMegaMenuItems(props.megaMenuItems);
});

function createMenuItemFromMegaMenuItem(item: IMegaMenuItem): IMobileMenuItem {
  const newItem: IMobileMenuItem = {
    title: item.isSeparator ? '' : item?.translation,
    expanded: false,
    url: item?.url,
  };

  if (item.hasItems) {
    newItem.items = createMenuItemsFromMegaMenuItems(item.items);
  }

  if (item.isSeparator) {
    newItem.separator = 'true';
  }

  return newItem;
}

function createMenuItemsFromMegaMenuItems(Items: Array<IMegaMenuItem>): Array<IMobileMenuItem> {
  if (!Items?.length) {
    return [];
  }

  return Items.map((item: IMegaMenuItem) => createMenuItemFromMegaMenuItem(item));
}

function handleSelect(...args: [PanelBarSelectEventArguments] | unknown[]) {
  const [event] = args as [PanelBarSelectEventArguments];
  if (event.target?.url && event.target?.url?.length > 2) {
    window.location.href = event.target?.url;
    emit('close-mobile-menu');
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(UserSearchBox, {
        onSearchClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close-mobile-menu')))
      }),
      (menuItems.value?.length > 0)
        ? (_openBlock(), _createBlock(_unref(KPanelBar), {
            key: 0,
            class: _normalizeClass('mobile-menu'),
            items: menuItems.value,
            onSelect: handleSelect
          }, null, 8, ["items"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})